import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../../../../enums/queryKeys'
import { fetchProfitAndLossReport } from '../../../../query-api'
import { ReportOptions } from '../../../../types/reportOptions'

interface UseFetchProfitAndLossReportProps {
  appliedFilters: ReportOptions
}

export const useFetchProfitAndLossReport = ({ appliedFilters }: UseFetchProfitAndLossReportProps) => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id || ''

  const { data, isLoading, isError } = useQuery(
    [
      QueryKeys.ProfitAndLoss,
      organizationId,
      appliedFilters.hideZeroes,
      appliedFilters.period,
      appliedFilters.compareCount,
      appliedFilters.compareWith,
    ],
    () => fetchProfitAndLossReport(organizationId, appliedFilters),
    {
      enabled: !!organizationId,
    },
  )

  return {
    isError,
    isLoading,
    data: data || null,
  }
}
